import { Observable } from 'rxjs/Rx';


export abstract class BaseService {

    constructor() { }

    protected handleErrorBase(error: any) {

    // TO-DO : Work on getting this error more coverage
    console.log("HTTP Error:" + error);

    var applicationError = error.headers.get('Application-Error');

    // either applicationError in header or model error in body
    if (applicationError) {
      return Observable.throw(applicationError);
    }

    var modelStateErrors: string = '';
    var serverError = error.json();

    if (!serverError.type) {
      for (var key in serverError) {
        if (serverError[key])
          modelStateErrors += serverError[key] + '\n';
      }
    }

    modelStateErrors = modelStateErrors = '' ? null : modelStateErrors;
    return Observable.throw(modelStateErrors || 'Server error');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/base.service.ts